export default __webpack_public_path__ + "static/media/Sneakers.3df6697f.gif";